import PreviewSectionInner from './preview-section-inner';

export default PreviewSectionInner;
